import { render, staticRenderFns } from "./ProductCards.vue?vue&type=template&id=6161331b"
import script from "./ProductCards.vue?vue&type=script&lang=js"
export * from "./ProductCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports